import {
  LAIAActivityPulse,
} from '../../platform/activity/LAIAActivityPulse'

import {
  ContextualMenu,
} from '../../platform/contextual/ContextualMenu'

import {
  Expand,
  ExternalLink,
  Mic,
  Paperclip,
  Send,
} from 'lucide-react'
import {
  useRef,
  useState,
} from 'react'
import ReactMarkdown from 'react-markdown'
import remarkGfm from 'remark-gfm'

import type {
  GenesisSession,
} from '../../services/genesisSession'

import {
  openLAIAWindow,
} from '../../services/genesisSession'

import {
  sendLAIAConversation,
} from '../../services/laiaConversation'

import {
  buildControlledWorkspaceMapping,
} from '../../services/laiaPhysicalMapping'




import {
  collectCoreObservability,
} from '../../services/coreObservability'
import {
  genesisUUID,
} from '../../utils/uuid'

import {
  LAIA_HEADER_TITLE,
} from '../../config/laiaBranding'

interface Props {
  session: GenesisSession
  focused?: boolean
}

interface Message {
  id: string
  role: 'USER' | 'LAIA'
  content: string
  authorizationRequired?: boolean
  authorizationId?: string | null
  engineeringSessionId?: string | null
}

export function LAIAWorkspace({
  session,
  focused = false,
}: Props) {
  const [
    expanded,
    setExpanded,
  ] =
    useState(focused)

  const [
    input,
    setInput,
  ] =
    useState('')


  const [
    attachments,
    setAttachments,
  ] =
    useState<File[]>([])

  const [
    messages,
    setMessages,
  ] =
    useState<Message[]>([
      {
        id:
          genesisUUID(),

        role:
          'LAIA',

        content:
`## LAIA Génesis

Esta será mi nueva área de trabajo.

Puedo mostrar respuestas enriquecidas:

- viñetas
- listas numeradas
- **negritas**
- encabezados
- tablas
- código
- evidencias

| Servicio | Estado |
|---|---|
| Conversación UI | Disponible |
| Adjuntos UI | Disponible |
| Segundo monitor | Disponible |

\`\`\`text

\`\`\`
`,
      },
    ])

  const fileRef =
    useRef<HTMLInputElement>(
      null,
    )

  function chooseFiles(
    list: FileList | null,
  ) {
    if (!list) return

    setAttachments(
      (current) => [
        ...current,
        ...Array.from(
          list,
        ),
      ],
    )
  }

  async function send() {
    // ============================================================



    const text =

      input.trim()


    if (

      !text &&

      attachments.length === 0

    ) {

      return

    }


    const attachmentNames =

      attachments.map(

        file =>

          file.name,

      )


    /*

     * GEN-VNEXT-02B1:

     * Attachments remain represented in conversation UI,

     * but binary upload will be connected through the

     * real file gateway in its own certified stage.

     */

    const wireMessage =

      [

        text,


        attachmentNames.length > 0

          ? `Adjuntos seleccionados: ${attachmentNames.join(', ')}`

          : '',

      ]

        .filter(Boolean)

        .join('\\n\\n')


    /*
     * C5-O14 controlled UI -> physical mapping certification.
     *
     * Restricted to certified WORKSPACE.
     * C5-O13 remains untouched.
     */
    const controlledPhysicalMapping =
      text ===
      'PRUEBA AUTOCAMBIO INTERFAZ: LAIA Genesis • C6'
        ? buildControlledWorkspaceMapping(
            '/opt/sei/genesis-clean/state/workspace/self-modification/laiaBranding.ts',
            "export const LAIA_HEADER_TITLE = 'LAIA Genesis • C6'\n",
          )
        : text.startsWith(
            'PRUEBA CAMBIO WORKSPACE:',
          )
          ? buildControlledWorkspaceMapping(
              '/opt/sei/genesis-clean/state/workspace/ui-real-e2e.txt',
              text
                .slice(
                  'PRUEBA CAMBIO WORKSPACE:'.length,
                )
                .trim(),
            )
          : null

    const previousHistory =

      messages

        .slice(-20)

        .map(

          message => ({

            role:

              message.role,


            text:

              message.content,


            moduleId:

              'laia',

          }),

        )


    const userMessage: Message = {

      id:

        genesisUUID(),


      role:

        'USER',


      content:

        wireMessage,

    }


    setMessages(

      current => [

        ...current,

        userMessage,

      ],

    )


    setInput('')

    setAttachments([])


    window.dispatchEvent(

      new CustomEvent(

        'sei:laia-processing',

        {

          detail: {

            active:

              true,


            label:

              'LAIA está analizando...',

          },

        },

      ),

    )


    try {

      const coreObservability =
  await collectCoreObservability()

window.dispatchEvent(
  new CustomEvent(
    'sei:laia-core-observability',
    {
      detail:
        coreObservability,
    },
  ),
)

const response =

        await sendLAIAConversation({

          conversationSessionId:

            session

              .conversationSessionId,


          message:

            wireMessage,


          context: {

            currentModule:

              'LAIA',


            route:

              `${window.location.pathname}${window.location.search}`,


            moduleId:

              'laia',


            metadata: {
              ...(controlledPhysicalMapping ?? {}),

              interface:

                'Genesis vNext',


              domain:

                window.location.hostname,


              attachmentsSelected:

                attachmentNames,

            },

          },


          history:

            previousHistory,


          mode:

            'SUPERVISED_FULL',


          requestedBy:

            'SUPER_ADMIN',

        })


      // P10_OPERATIONAL_TRUTH_VISIBLE_V2
      const operationalDetails = [
        response.status
          ? `Estado: ${response.status}`
          : null,

        response.engineeringState
          ? `Ingeniería: ${String(response.engineeringState)}`
          : response.data?.engineeringStatus
            ? `Ingeniería: ${String(response.data.engineeringStatus)}`
            : null,

        response.data?.target
          ? `Target: ${String(response.data.target)}`
          : null,

        response.data?.proposalId
          ? `Propuesta: ${String(response.data.proposalId)}`
          : null,

        response.data?.simulationId
          ? `Simulación: ${String(response.data.simulationId)}`
          : null,

        response.data?.validationId
          ? `Validación: ${String(response.data.validationId)}`
          : null,

        response.authorizationRequired
          ? 'Autorización humana: requerida'
          : null,
      ].filter(Boolean)

      const visibleOperationalMessage =
        operationalDetails.length > 0
          ? [
              response.message,
              '',
              '---',
              ...operationalDetails,
            ].join('\\n')
          : response.message

      // ============================================================
      // SEI_AUTHORIZATION_MESSAGE_NORMALIZER_V1
      //
      // Normalize the engineering authorization contract so the
      // conversational HUMAN_ONCE bridge does not depend on a single
      // response nesting shape.
      // ============================================================

      const responseRecord = response as unknown as Record<string, any>
      const responseData =
        responseRecord?.data &&
        typeof responseRecord.data === 'object'
          ? responseRecord.data
          : {}

      const operational =
        responseData?.operationalDetails &&
        typeof responseData.operationalDetails === 'object'
          ? responseData.operationalDetails
          : {}

      const normalizedAuthorizationId =
        typeof responseData?.authorizationId === 'string'
          ? responseData.authorizationId
          : typeof operational?.authorizationId === 'string'
            ? operational.authorizationId
            : typeof responseRecord?.authorizationId === 'string'
              ? responseRecord.authorizationId
              : null

      const normalizedEngineeringSessionId =
        typeof responseData?.engineeringSessionId === 'string'
          ? responseData.engineeringSessionId
          : typeof operational?.engineeringSessionId === 'string'
            ? operational.engineeringSessionId
            : typeof responseRecord?.engineeringSessionId === 'string'
              ? responseRecord.engineeringSessionId
              : null

      const normalizedStatus = String(
        responseRecord?.status ??
        responseData?.status ??
        responseData?.engineeringStatus ??
        '',
      ).toUpperCase()

      const normalizedAuthorizationRequired =
        responseRecord?.authorizationRequired === true ||
        responseData?.authorizationRequired === true ||
        operational?.authorizationRequired === true ||
        normalizedStatus === 'AUTHORIZATION_REQUIRED' ||
        Boolean(
          normalizedAuthorizationId &&
          normalizedEngineeringSessionId,
        )

      const laiaMessage: Message = {
        id: genesisUUID(),
        role: 'LAIA',
        content: visibleOperationalMessage,
        authorizationRequired:
          normalizedAuthorizationRequired,
        authorizationId:
          normalizedAuthorizationId,
        engineeringSessionId:
          normalizedEngineeringSessionId,
      }

      setMessages(

        current => [

          ...current,

          laiaMessage,

        ],

      )


      window.dispatchEvent(

        new CustomEvent(

          'sei:laia-conversation-result',

          {

            detail:

              response,

          },

        ),

      )

    } catch (error) {

      const detail =

        error instanceof Error

          ? error.message

          : 'Error desconocido al comunicarse con LAIA.'


      const errorMessage: Message = {

        id:

          genesisUUID(),


        role:

          'LAIA',


        content:

          [

            '**No pude completar la comunicación con LAIA Génesis.**',

            '',

            detail,

          ].join('\\n'),

      }


      setMessages(

        current => [

          ...current,

          errorMessage,

        ],

      )

    } finally {

      window.dispatchEvent(

        new CustomEvent(

          'sei:laia-processing',

          {

            detail: {

              active:

                false,

            },

          },

        ),

      )

    }

  }

  return (
    <section
      className={
        expanded
          ? 'laia-panel expanded'
          : 'laia-panel'
      }
    >

      <header className="laia-header">

        <div>
          <strong>
            {LAIA_HEADER_TITLE}
          </strong>

          <small>
            {
              session
                .conversationSessionId
                .slice(
                  0,
                  31,
                )
            }
          </small>
        </div>

        <div className="laia-actions">
        <div className="laia-action-context">
          <ContextualMenu
            id="surface:laia"
            title="LAIA Génesis"
            allowHide={false}
          />
        </div>

        <span
          className="laia-action-separator"
          aria-hidden="true"
        />

        <button
            type="button"
            title="Expandir"
            onClick={() =>
              setExpanded(
                (value) =>
                  !value,
              )
            }
          >
            <Expand
              size={17}
            />
          </button>

          <button
            type="button"
            title="Abrir en otro monitor"
            onClick={() =>
              openLAIAWindow(
                session
                  .conversationSessionId,
              )
            }
          >
            <ExternalLink
              size={17}
            />
          </button>
        </div>

      </header>

      <LAIAActivityPulse />

      <div className="conversation">

        {messages.map(
          (message) => (
            <article
              key={
                message.id
              }
              className={
                `message ${
                  message.role
                    .toLowerCase()
                }`
              }
            >

              <div className="role">
                {
                  message.role ===
                  'USER'
                    ? 'TÚ'
                    : 'LAIA GÉNESIS'
                }
              </div>

              <ReactMarkdown
                remarkPlugins={[
                  remarkGfm,
                ]}
              >
                {
                  message.content
                }
              </ReactMarkdown>


            </article>
          ),
        )}

      </div>

      {
        attachments.length >
          0 && (
          <div className="attachments">

            {
              attachments.map(
                (
                  file,
                  index,
                ) => (
                  <div
                    className="attachment"
                    key={
                      `${file.name}-${index}`
                    }
                  >
                    <Paperclip
                      size={14}
                    />

                    <span>
                      {file.name}
                    </span>

                    <button
                      type="button"
                      onClick={() =>
                        setAttachments(
                          (
                            current,
                          ) =>
                            current.filter(
                              (
                                _,
                                i,
                              ) =>
                                i !==
                                index,
                            ),
                        )
                      }
                    >
                      ×
                    </button>
                  </div>
                ),
              )
            }

          </div>
        )
      }

      <footer className="composer">

        <input
          ref={fileRef}
          hidden
          multiple
          type="file"
          onChange={
            (event) =>
              chooseFiles(
                event
                  .target
                  .files,
              )
          }
        />

        <button
          type="button"
          title="Adjuntar archivos"
          onClick={() =>
            fileRef.current
              ?.click()
          }
        >
          <Paperclip
            size={18}
          />
        </button>

        <button
          type="button"
          title="Voz"
        >
          <Mic size={18} />
        </button>

        <textarea
          value={input}
          placeholder="Habla o construye con LAIA Génesis..."
          onChange={
            (event) =>
              setInput(
                event
                  .target
                  .value,
              )
          }
          onKeyDown={
            (event) => {
              if (
                event.key ===
                  'Enter' &&
                !event
                  .shiftKey
              ) {
                event
                  .preventDefault()

                send()
              }
            }
          }
        />

        <button
          type="button"
          className="send"
          onClick={send}
        >
          <Send size={18} />
        </button>

      </footer>

    </section>
  )
}
